import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

import { getNotifications } from '~/actions/notifications'
import { getUserCamps } from '~/actions/camps'
import { getUserInterests } from '~/actions/interests'
import { getUserBookmarks } from '~/actions/bookmarks'
import { getUserViewHistory } from '~/actions/viewhistory'

import TextTemplate from '../RegistrationParts/TextSlideTemplate'


export default class extends React.Component {
    static propTypes = {
		changeData: PropTypes.func.isRequired,
		dispatch: PropTypes.func.isRequired,
		prevSlide: PropTypes.func.isRequired,
		nextSlide: PropTypes.func.isRequired,
		history: PropTypes.object.isRequired,
	};

    state = {
        field: 'completed'
    };

    componentDidMount() {
		this.props.dispatch( getNotifications() )
		this.props.dispatch( getUserCamps() )
		this.props.dispatch( getUserInterests() )
		this.props.dispatch( getUserBookmarks() )
		this.props.dispatch( getUserViewHistory() )
	}

    completeRegistration = (e) => {

		var data = {};
		data[ this.state.field ] = 1
		this.props.changeData({}, data)
		this.props.nextSlide();
		this.props.history.push({returnTo: '/'}, '/me');

	};

    render() {

		var content = <p className="text-center text-white mbot30">
			Your answers help to make sure Five to Nine Club is only putting content in front of you which helps you to achieve your goals. You can make changes 24/7 on your profile by clicking settings.
			<br />
			<br />
			Let’s check your profile
		</p>;

		return (
			<TextTemplate 
				title={<span className="text-white">All done!</span>}
				content={content}
				continue="Let's go explore"
				prevSlide={this.props.prevSlide}
				nextSlide={this.completeRegistration}
				/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Registration/RegistrationSlides/AllDoneSlidePart.jsx